/* eslint react/jsx-filename-extension: 0 */
import { Amplify } from "aws-amplify";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import Routes from "./routes";
import amplifyConfig from "./config/amplify";

import "../semantic-ui/semantic.less";

Amplify.configure(amplifyConfig);

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);
